$(function() {
  // 1. 获取所有下拉菜单（.tw-drop），默认显示第一个
  const $dropdowns = $('.t4s-lazy_menu .tw-drop');
  $dropdowns.hide().first().show(); // 更简洁的写法
  
  // 2. 缓存父容器和菜单项
  const $menuContainer = $('.t4s-sub-link');
  const $menuItems = $menuContainer.find('.t4s-menu-item[id^="t4s-sub-item-"]');

  // 3. 事件委托：鼠标悬停菜单项时
  $menuContainer.on('mouseenter', '.t4s-menu-item[id^="t4s-sub-item-"]', function() {
    const $currentItem = $(this);
    const index = $menuItems.index($currentItem); // 更精确的索引获取
    
    // 移除所有 active 类
    $menuItems.removeClass('active');
    $dropdowns.removeClass('active').hide();

    // 当前菜单项 + 对应下拉菜单激活
    $currentItem.addClass('active');
    const $targetDropdown = $dropdowns.eq(index);
    $targetDropdown.addClass('active').show();
    
  });

});